import { Component, OnInit } from '@angular/core';
import { AssetService } from '../../../../services/asset.service';
import { environment } from '../../../../../environments/environment';
import _ from 'lodash';

@Component({
    selector: 'app-note-info-box',
    templateUrl: './note-info-box.component.html',
    styleUrls: ['./note-info-box.component.scss'],
    standalone: true
})
export class NoteInfoBoxComponent implements OnInit {

    private static STORAGE_KEY = 'hideNoteInfoBox';

    mobileBreakpoint = environment.mobileBreakPoint;
    noteInfoIconUrl: string;
    showBox: boolean;
    debouncedOnResize: (() => void) & _.Cancelable;

    private localStorage: Storage;

    constructor(private assetService: AssetService) {
        this.localStorage = window.localStorage;
    }

    ngOnInit(): void {
        this.noteInfoIconUrl = this.assetService.getUrl('notes/note-info.png');
        this.showBox = !this.localStorage.getItem(NoteInfoBoxComponent.STORAGE_KEY) &&
            window.window.innerWidth > this.mobileBreakpoint + 1;
        this.debouncedOnResize = _.debounce(this.onResize, 300);
    }

    hideBox(): void {
        this.localStorage.setItem(NoteInfoBoxComponent.STORAGE_KEY, 'true');
        this.showBox = false;
    }

    revealElements(): void {
        $('#sidebarWrapper')
            .css('z-index', 98);
        ($ as any).revealElements({
            revealClass: '.reveal',
            wrapperEl: 'body',
            overlayIndex: 99,
            overlayColor: '#222'
        });
        setTimeout(() => {
            ($ as any).removeReveal();
            $('#sidebarWrapper')
                .css('z-index', 1000);
        }, 2500);

    }

    private onResize(): void {
        this.showBox = !this.localStorage.getItem(NoteInfoBoxComponent.STORAGE_KEY) &&
            window.window.innerWidth > this.mobileBreakpoint;
    }
}
